import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

import { ImportDialogState } from "./types";

interface Props {
  dialogState: ImportDialogState<unknown>;
  onClose: () => void;
  onSave: () => void;
  onFileConfirm: () => void;
}

export const ResourcesImportButtons = ({ dialogState, onClose, onSave, onFileConfirm }: Props) => {
  const activeStep = dialogState.step;

  return (
    <DialogActions>
      {activeStep !== 2 && <Button onClick={onClose}>Cancel</Button>}

      {activeStep === 0 && (
        <Button
          onClick={onFileConfirm}
          disabled={!dialogState.file}
          variant="contained"
          data-testid="nextButton"
        >
          Next
        </Button>
      )}
      {activeStep === 1 && (
        <Button
          onClick={onSave}
          variant="contained"
          disabled={!dialogState.importedResources}
          data-testid="saveButton"
        >
          Save
        </Button>
      )}
      {activeStep === 2 && (
        <Button
          onClick={onClose}
          variant="contained"
          disabled={!dialogState.status}
          data-testid="closeButton"
        >
          Close
        </Button>
      )}
    </DialogActions>
  );
};
